// ============================================================
// TMR Portal Admin — as colunas da planilha de Contratos de paciente
// ============================================================
import {
  formatPatientDocument,
  patientContractStatusLabel,
} from '../../data/patientContracts/status';
import type { PatientContractRow } from '../../data/patientContracts/contract';
import type { ExportColumn } from '../../lib/export/types';

/**
 * The patient contracts list as a spreadsheet (20 §9).
 *
 * **The clinic is named twice, and both are needed.** The trade name is what a person reads; the legacy
 * producer id is what always resolves — a clinic the V2 has no Empresa for yet leaves the first blank, and
 * a spreadsheet where some rows have no clinic at all would look like missing data rather than a base
 * still being backfilled (19).
 *
 * **The signed PDF is not here and cannot be.** A spreadsheet carries values, and the file is served by an
 * endpoint that checks the permission on every request. What the export carries instead is whether there
 * is one, which is the question somebody reconciling a batch actually asks.
 */
export const PATIENT_CONTRACT_EXPORT_COLUMNS: ExportColumn<PatientContractRow>[] = [
  { header: 'Número', value: (c) => c.number },
  { header: 'Paciente', value: (c) => c.patientName ?? '' },
  { header: 'CPF', value: (c) => (c.patientDocument ? formatPatientDocument(c.patientDocument) : '') },
  { header: 'Clínica', value: (c) => c.companyName ?? '' },
  { header: 'Produtor no legado', value: (c) => c.legacyProducerId },
  { header: 'Documento', value: (c) => c.documentTypeName },
  { header: 'Título', value: (c) => c.title },
  { header: 'Situação', value: (c) => patientContractStatusLabel(c.status) },
  { header: 'Emitido em', value: (c) => c.issuedAt },
  { header: 'Assinado em', value: (c) => c.signedAt ?? '' },
  { header: 'PDF disponível', value: (c) => (c.hasPdf ? 'Sim' : 'Não') },
  // The one column somebody filters the spreadsheet by when they are chasing a batch that did not finish.
  { header: 'Processamento falhou', value: (c) => (c.processingFailed ? 'Sim' : 'Não') },
];
